const offsetTimezone = ( date, format ) => {
	if ( !date ) {
		return null;
	}

	const newD = new Date( date );

	const offsetD = new Date( newD.getTime() - newD.getTimezoneOffset() * 60000 );

	switch ( format ) {
		case 'dateTime':
			return offsetD.toLocaleString();
		case 'date':
			return offsetD.toLocaleDateString();
		case 'time':
			return offsetD.toLocaleTimeString();
		case 'ISO':
			return offsetD.toISOString();
		default:
			return offsetD;
	}
};

export default offsetTimezone;
